define('editor/edit/layers/edit/overlay',['./layerBase', 'knockout', 'knockout-mapping', 'plugins/http', 'durandal/app', 'jquery', 'no-ui-slider'], function (layerBase, ko, komapping, http, app, $, noUiSlider) {
    var viewmodel = function () {
        var self = this;

        var moduleId = self.__moduleId__;
        self.base = new layerBase();
        $.extend(self, self.base);
        self.__moduleId__ = moduleId;

        self.opacity = ko.observable();

        self.activate = function(editorMapId, layer, backToListFunc) {
            self.base.activate(editorMapId, layer, backToListFunc);
            self.editorMapId = editorMapId;
            self.layer = layer;

            self.opacity(self.layer.state().options.opacity() * 100);

            self.changes = ko.computed(function() {
                // want to be notified of changes to these properties
                return self.opacity();
            });

            self.changes.subscribe(function() {
                // update layer observables and notify
                self.layer.state().options.opacity(self.opacity() / 100);

                app.trigger("layers:updated", [self.layer]);
            });
        };

        self.compositionComplete = function() {
            var slider = $('.slider'),
                sliderStart = self.opacity();

            if (slider.length) {
                noUiSlider.create(slider.get(0),
            {
                start: sliderStart,
                step: 1,
                tooltips: true,
                    connect: "lower",
                    orientation: "horizontal",
                    range: {
                        'min': 0,
                        'max': 100
                    },
                    serialization: {
                        format: {
                            decimals: 0
                        }
                    }
                });

                slider.get(0).noUiSlider.on('change', function () {
                    var newValue = slider.get(0).noUiSlider.get();
                    self.opacity(newValue);
                });
            }
        };
    };

    return viewmodel;
});

